import React from 'react'
import { Sparkles, Zap } from 'lucide-react'
import { useSubscription } from '@/features/subscription/hooks/useSubscription'
import { Link } from 'react-router-dom'
import { cn } from '@/shared/lib/utils'

export const SidebarUsageWidget = () => {
    const { subscription, creditBalance, loading } = useSubscription()

    if (loading) return null

    // Default to 100 if maxCredits not set (just for visual)
    const maxCredits = subscription?.maxCredits || 100
    const percentage = Math.min(Math.round((creditBalance / maxCredits) * 100), 100)

    return (
        <div className="mx-4 mb-4 p-4 rounded-xl bg-sidebar-accent/50 border border-sidebar-border overflow-hidden relative group transition-all duration-300 hover:bg-sidebar-accent">
            <div className="absolute -right-8 -top-8 w-16 h-16 bg-primary/10 blur-2xl rounded-full group-hover:bg-primary/20 transition-all duration-300"></div>
            
            <div className="flex items-center justify-between mb-2">
                <span className="text-[10px] uppercase tracking-wider font-bold text-muted-foreground flex items-center gap-1">
                    <Zap className="w-3 h-3 text-amber-500" />
                    Credits
                </span>
                <span className="text-xs font-medium">
                    {creditBalance} / {maxCredits}
                </span>
            </div>

            <div className="w-full h-1.5 bg-sidebar-border rounded-full overflow-hidden mb-3">
                <div 
                    className={cn(
                        "h-full transition-all duration-500 ease-in-out",
                        percentage > 80 ? "bg-amber-500" : percentage > 50 ? "bg-primary" : "bg-primary/80"
                    )}
                    style={{ width: `${percentage}%` }}
                />
            </div>

            <Link 
                to="/pricing" 
                className="flex items-center justify-center gap-2 w-full py-1.5 rounded-lg bg-primary text-primary-foreground text-[11px] font-bold transition-transform active:scale-95 border border-primary/20 shadow-sm hover:shadow-primary/20"
            >
                <Sparkles className="w-3 h-3" />
                Upgrade Plan
            </Link>
        </div>
    )
}
